export function IconDiamondGold() {
  return (
    <g transform="scale(0.4)">
      <path
        d="M86.4688 21.875L76.6875 18.0938L61.5313 18.2187L61 18.0938L60.625 18.25L38.9688 18.4375L38.8125 18.375L38.5938 18.4375L23.3125 18.5625L12.8438 22.6562L0.4375 35.625L0.25 36.4062L4.21875 40.9375L11.2188 48.9062L37.9375 72.0625L50.25 81.8438L63.0313 71.2812L88.2188 48.9062L95.9688 40.4688L99.75 36.4062V34.9375L86.4688 21.875Z"
        fill="#F5EDE0"
      />

      <g stroke="#AB7C08" strokeWidth="0.416406">
        <path d="M76.6875 18.1562L23.3125 18.6562L12.8438 22.7187L0.4375 35.6875L0.25 36.4687L4.21875 41.0312L11.1875 48.9687L37.9375 72.125L50.25 81.9062L63.0313 71.3437L88.2188 48.9687L95.9688 40.5312L99.75 36.4687V35.0312L86.4688 21.9375L76.6875 18.1562Z" />

        <path d="M63.4067 70.875L85.688 48.1875L58.188 72.4063L64.8755 48.1875L50.2505 72.625L34.938 48.2812L41.9067 72.4063L14.5942 48.875L34.6567 69.2188" />
        <path d="M77.2812 48.4062L58.1875 72.4062L50.25 81.9062L41.9062 72.4062L22.9062 49.25" />
        <path d="M50.2505 81.9062V48.2812L40.938 40.5312L34.938 48.2812L24.0005 40.8437L22.9067 49.25L11.2817 40.6562L14.5942 48.875L4.21924 41.0312" />
        <path d="M50.251 48.2813L59.1572 40.6563L64.876 48.1875L75.9072 40.4375L77.2822 48.4063L88.7822 40.3438L85.6885 48.1875L95.4697 40.9375L95.7197 36.1562L88.7822 40.3438L85.0322 36.2812L75.9072 40.4375L68.9385 36.4688L59.1572 40.6563L49.9385 36.6562L40.9385 40.5313L31.0635 36.7188L24.001 40.8438L15.0635 36.7188L11.2822 40.6563L4.34473 36.6875L4.03223 40.5313L1.21973 36.2812" />
        <path d="M0.25 36.4688L1.21875 36.2812L4.3125 36.5625H8.6875L15.0625 36.6562L22.25 36.4688L31.0625 36.6562L40.1563 36.4688L49.9375 36.6562L59.625 35.9062L68.9375 36.4688L77.375 36L85.125 36.1875L91.125 35.8125L95.875 36L98.375 35.8125L99.75 36.4688" />
        <path d="M0.438477 35.6875L4.12598 34.7187L8.96973 36.0938L14.6885 35.125L22.3447 35.9062L30.7822 34.3437L40.1572 35.8125L49.751 35.2188L59.1572 35.5L69.2197 33.9687L77.376 35.5L84.7197 34.9375L91.0322 35.3125L95.5635 33.75L98.6885 35.4062L99.751 35.0312" />

        <path d="M59.1572 40.6563L59.626 35.9062" />
        <path d="M40.938 40.5313L40.1567 36.4688" />
        <path d="M24.0005 40.8437L22.2505 36.4688" />
        <path d="M11.3755 40.5312L8.96924 36.625" />
        <path d="M75.9062 40.4375L77.375 36" />
        <path d="M88.7817 40.3437L91.1255 35.8125" />
        <path d="M95.9688 40.5313L98.375 35.8125" />

        <path d="M86.4687 21.9375L95.5625 33.75L75.625 21.9375L69.2187 33.9687L49.9062 22.4375" />
        <path d="M12.8442 22.7188L4.12549 34.7188L24.0005 22.4375L30.7817 34.25L49.9067 22.4375V35.2188" />
        <path d="M76.6875 18.1562L75.625 21.9375L61 18.375L49.9063 22.4375L38.7812 18.5937L24 22.4375L23.3125 18.6562" />

        <path d="M8.96924 36.0937L19.438 28.4375L22.3442 35.9062" />
        <path d="M40.1567 35.8125L49.8442 28.0625L59.1567 35.5" />
        <path d="M77.375 35.5L80.1875 27.75L91.0312 35.3125" />
        <path d="M84.7192 34.9375L80.188 27.75L75.6255 21.9375" />
        <path d="M24.0005 22.4375L19.438 28.4375L14.688 35.125" />
      </g>

      <g fill="#AB7C08" opacity="0.12">
        <path d="M58.312 40.8125L50.1558 47.5937L41.812 40.6562L58.312 40.8125Z" />
        <path d="M36.0312 48.25L49.25 70.125L40.9063 41.9375L36.0312 48.25Z" />
        <path d="M64.0937 48.2188L50.875 70.0938L59.2188 41.9062L64.0937 48.2188Z" />
        <path d="M52.0938 22.4375L61 19.0938L74.625 22.4375H52.0938Z" />
        <path d="M79.8125 23.8438L86.875 23.5625L93.0625 31.75L79.8125 23.8438Z" />
        <path d="M20.2187 23.8438L13.1562 23.5625L6.96875 31.75L20.2187 23.8438Z" />
        <path d="M13.0312 46.2813L4.96875 38.0938L4.75 40.6563L13.0312 46.2813Z" />
        <path d="M27.8433 59.3438L12.937 42.8125L15.2808 48.5L27.8433 59.3438Z" />
        <path d="M72.5 58.7812L87.4062 42.25L85.0625 47.9375L72.5 58.7812Z" />
        <path d="M86.7812 46.2813L94.8438 38.0938L95.0625 40.6563L86.7812 46.2813Z" />
        <path d="M76.938 41.0313L84.6255 37.3125L77.7817 47.1875L76.938 41.0313Z" />
        <path d="M63.3438 56.8125L73.7188 51.8125L60.625 68.3125L63.3438 56.8125Z" />
        <path d="M36.625 56.8125L26.25 51.8125L39.3438 68.3125L36.625 56.8125Z" />
        <path d="M22.9683 41.1563L15.2808 37.4375L22.1245 47.2813L22.9683 41.1563Z" />
        <path d="M28.0005 31.4687L23.6567 23.5L20.5005 28.0625L28.0005 31.4687Z" />
        <path d="M71.4692 31.4687L75.813 23.5L78.9692 28.0625L71.4692 31.4687Z" />
        <path d="M59.3125 34.8437L57.3125 27.7812L67.1875 33.7812L59.3125 34.8437Z" />
        <path d="M40.1875 35.1875L42.1875 28.0938L32.3125 34.0938L40.1875 35.1875Z" />
        <path d="M47.7505 22.4375L38.813 19.0938L25.2192 22.4375H47.7505Z" />
      </g>
    </g>
  )
}
